export default {
  setInterval: (fn: CallableFunction, timeout: number): number => setInterval(fn, timeout),
  setTimeout: (fn: CallableFunction, timeout: number): number => setTimeout(fn, timeout),
  clearTimeout: (handle: number): void => clearTimeout(handle),
  clearInterval: (handle: number): void => clearInterval(handle),
}
